export const REGEXRAFORMAT1= /^(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:([0-5]\d)(\.(\d{1,9}))?)$/gm ; //HH:MM:SS.S*
export const REGEXRAFORMAT2= /^(?:[01]\d|2[0-3])h(?:[0-5]\d)m(?:([0-5]\d)(\.(\d{1,9}))?s)$/gm; //12h13m34.20s
export const REGEXRAFORMAT3= /^(\d)*((\.\d*)?)$/gm;

export const REGEXDECFORMAT1= /^(?:([-+]?([0-8]\d|9[0]))):(?:[0-5]\d):(?:([0-5]\d)(\.(\d{1,9}))?)$/gm; //DD:MM:SS.s
export const REGEXDECFORMAT2= /^(?:([-+]?([0-8]\d|9[0])))d(?:[0-5]\d)m(?:([0-5]\d)(\.(\d{1,9}))?s)$/gm; //+12d13m34.20s
export const REGEXDECFORMAT3= /^[-+]?((([0-8]\d?)|[9])(\.\d*)?)$|^[-+]?(90)$/gm; // dec in [-90, 90]

export const EMPTY=/^\s*$/;

export const REGEXDRNAME= /(^[a-z_])[a-z0-9_]{2,11}$/gm;

export const REGEXSEARCHURLPATHNAME= /release[\/](.*)[\/]search/g;
